import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="relative rounded-3xl overflow-hidden mb-12">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20lifestyle%20photography%20of%20a%20neat%20desk%20setup%20with%20a%20laptop%20displaying%20spreadsheet%20interface%20and%20shopping%20list%2C%20cream%20and%20sage%20green%20color%20palette%2C%20soft%20natural%20daylight%20from%20a%20window%2C%20cozy%20textured%20linen%20and%20ceramic%20mug%2C%20editorial%20workspace%20aesthetic%2C%20warm%20atmospheric%20mood%2C%20high%20detail&width=1400&height=600&seq=cta-lifestyle-gtbuy&orientation=landscape"
            alt="GTBuy Spreadsheet workspace lifestyle"
            className="w-full h-[300px] md:h-[400px] object-cover"
          />
        </div>

        <div className="text-center">
          <p className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            Start Smart Shopping
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            <span className="italic font-normal text-foreground-500">Save Money,</span>
            <br />
            Skip the Hassle
          </h2>
          <p className="mt-5 text-foreground-600 max-w-lg mx-auto leading-relaxed">
            Start using spreadsheet-based shopping intelligence today. Compare across platforms, track prices over time, and never overpay again.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm cursor-pointer whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              Explore GTBuy Spreadsheet
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <Link
              to="/article/what-is-gtbuy-spreadsheet"
              className="inline-flex items-center px-8 py-3.5 rounded-full border-2 border-primary-500 text-primary-700 font-semibold text-sm cursor-pointer whitespace-nowrap hover:bg-primary-500 hover:text-background-50 transition-colors"
            >
              Read the Guide
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}